import { render } from "./EditorField.vue?vue&type=template&id=2d0e2d64"
import script from "./EditorField.vue?vue&type=script&lang=js"
export * from "./EditorField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__